import React from "react";

const ProContext = React.createContext(false);

export default ProContext;
